import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faPhoneAlt,
  faEnvelope,
  faCarCrash,
  faCar,
  faCoins,
  faTools,
  faMoneyBill,
  faFolderOpen,
  faTruckPickup,
  faUmbrella,
  faCheckCircle,
  faTimesCircle
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faPhoneAlt,
  faEnvelope,
  faCarCrash,
  faCar,
  faCoins,
  faTools,
  faMoneyBill,
  faFolderOpen,
  faTruckPickup,
  faUmbrella,
  faCheckCircle,
  faTimesCircle
);
